import moment from 'moment';

const momentLocaleCode = {
  'CN': 'zh-cn',
}

const code = localStorage.getItem('language');

let language = momentLocaleCode[code] || 'en';

moment.locale(language);



// WEBPACK FOOTER //
// ./src/locale/localeMoment.js